export default "__VITE_ASSET__J$xiWlR8TTtNtiB4XwZIUA__"